export default __webpack_public_path__ + "static/media/im-image-section.7f6ea420.png";